<template>
<div class="container-fluid">
    <div class="card mt-3 mb-5 system-font">
        <div class="card-header d-flex align-items-center am-main-box am-main-top-box">
            <div class="mr-auto am-main-box-title am-main-top-box-title">Commission Filing</div>
            <a href="/downloadCommissions.php">
              <svg-icon class="am-glyphicon-medium am-glyphicon-white" icon="import" title="Import"></svg-icon>
            </a>
            <a class="ml-1" href="#" @click.prevent="startHelpTour">
              <svg-icon class="am-glyphicon-medium am-glyphicon-white" icon="help" title="Help"></svg-icon>
            </a>
            <a class="ml-1" href="#" @click.prevent="archive" title="Archive">
              <svg-icon class="am-glyphicon-medium am-glyphicon-white" icon="hide" title="Hide"></svg-icon>
            </a>
            <a class="ml-1" href="#" @click.prevent="checkUnsavedAdjustments">
              <svg-icon class="am-glyphicon-medium am-glyphicon-white" icon="back" title="Back"></svg-icon>
            </a>
        </div>
        <div class="card-body" style="min-height: 10rem;">
            <div v-show="error">
                <div class="alert alert-danger" role="alert">{{ error }}</div>
            </div>
            <div class="row" v-if="file">
                <div class="col-6">
                    <table>
                        <tr>
                            <td class="text-right"><strong>Creator:</strong></td>
                            <td class="pl-3">{{ file.creator }}</td>
                        </tr>
                        <tr>
                            <td class="text-right"><strong>Rundate:</strong></td>
                            <td class="pl-3">{{ file.filingDate }}</td>
                        </tr>
                        <tr>
                            <td class="text-right"><strong>Deposit Date:</strong></td>
                            <td class="pl-3">{{ file.depositDate }}</td>
                        </tr>
                        <tr>
                            <td class="text-right"><strong>Start Date:</strong></td>
                            <td class="pl-3">{{ file.startDate }}</td>
                        </tr>
                        <tr>
                            <td class="text-right"><strong>End Date:</strong></td>
                            <td class="pl-3">{{ file.endDate }}</td>
                        </tr>
                    </table>
                </div>
                <div class="col-6">
                    <table class="ml-auto">
                        <thead>
                            <tr>
                                <th class="text-center" colspan="2">Grand Totals</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr>
                                <td class="text-right">Line Items:</td>
                                <td class="pl-3 text-right">{{ stats.count }}</td>
                            </tr>
                            <tr>
                                <td class="text-right">Premium:</td>
                                <td class="pl-3">
                                    <div class="d-flex justify-content-between"><span>$</span><span class="pl-1">{{ stats.total_commissionable | number }}</span></div>
                                </td>
                            </tr>
                            <tr>
                                <td class="text-right">Adjusted:</td>
                                <td class="pl-3">
                                    <div class="d-flex justify-content-between"><span>$</span><span class="pl-1">{{ stats.total_adjusted | number }}</span></div>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>
        </div>
        <b-navbar>
            <b-navbar-nav class="mr-auto am-main-tabs navbar-expand-lg" ref="tabsContainer">
                <li v-for="{value, text} in filterOptions.status" :class="filter.status === value ? 'am-main-tab-current' : ''"><a class="btn system-font btn-tabs btn-primary" type="button" @click="filter.status = value" :id="text.toLowerCase()">{{ text }}<span class="badge">{{ stats[text.toLowerCase()] }}</span></a></li>
            </b-navbar-nav>
        </b-navbar>
        <div class="card-body position-relative" v-if="file">
            <div class="form-inline">
                <customer-form class="mr-2" slot="action" v-if="!isArchived &amp;&amp; filter.status === 1" :file="file" id="addCommissionDetail" @detailCreated="loadPage"></customer-form>
                <div class="btn-group system-font">
                    <b-btn id="stageBtn" v-if="filter.status === 1" :disabled="selected.length === 0" size="sm" variant="primary" @click="updateStatus(2)">Stage Selected</b-btn>
                    <b-btn id="saveBtn" v-if="filter.status === 1" size="sm" variant="primary" @click="saveAdjustments">Save Adjusted Amounts</b-btn>
                    <b-btn id="forwardBtn" v-if="filter.status === 1" :disabled="selected.length === 0" size="sm" variant="primary" @click="updateStatus(4)">Forward Selected</b-btn>
                    <b-btn id="deleteBtn" v-if="filter.status === 1" :disabled="selected.length === 0" size="sm" variant="primary" @click="deleteSelected">Delete Selected</b-btn>
                    <b-btn id="unstageBtn" v-if="filter.status === 2" :disabled="selected.length === 0" size="sm" variant="primary" @click="updateStatus(1)">UnStage Selected</b-btn>
                    <b-btn id="statementsBtn" v-if="filter.status === 2" size="sm" variant="success">
                        <old-link id="statementsLink" to="#/admin/commission/statements">Go to Statements</old-link>
                    </b-btn>
                    <b-btn id="unforwardBtn" v-if="filter.status === 4" :disabled="selected.length === 0" size="sm" variant="primary" @click="updateStatus(1)">UnForward Selected</b-btn>
                </div>
                <div class="form-group mr-2">
                    <div class="d-flex flex-column align-items-start">
                        <b-form-select class="system-dropdown system-font" v-model="filter.source" :options="filterOptions.source" id="sourceFilter" size="sm"></b-form-select>
                    </div>
                </div>
                <div class="form-group mr-2">
                    <div class="d-flex flex-column align-items-start">
                        <b-form-select class="system-dropdown system-font" v-model="filter.company" :options="filterOptions.company" id="companyFilter" size="sm"></b-form-select>
                    </div>
                </div>
                <div class="form-group mr-auto">
                    <b-btn id="resetBtn" size="sm" variant="primary" @click="clearFilter">Reset</b-btn>
                </div>
                <div class="form-group">
                    <page-items v-if="details.length !== 0" :pagination="pagination" @setPage="loadPage" @setPageSize="pagination.per_page = $event"></page-items>
                </div>
            </div>
            <div class="border border-info" id="border-div">
                <company-table id="company-table" @adjust="saveAdjustments" @sort="sortBy" @bulkAction="bulkAction = $event" v-model="details" :sort="sort" :totalCount="pagination.total" :editable="filter.status === 1 &amp;&amp; !isArchived"></company-table>
                <div class="text-right" id="page-navigator">
                    <pageNavigator :pagination="pagination" @setPage="loadPage" @setPageSize="pagination.per_page = $event" v-if="details.length !== 0"></pageNavigator>
                </div>
            </div>
        </div>
        <div class="card-footer bg-white">
            <div class="tag-info ml-3"><small class="d-block mb-2"><span class="tag tag-red mr-1"></span><span class="margin-left">Indicates an imported commission</span></small><small class="d-block mb-2"><span class="tag tag-blue mr-1"></span><span class="margin-left">Indicates an forwarded commission</span></small>
                <small
                    class="d-block"><span class="tag tag-green mr-1"></span><span class="margin-left">Indicates an manually added commission</span></small>
            </div>
        </div>
        <div class="am-main-box am-main-bottom-box"></div>
        <v-tour name="helpTour" :steps="steps" :callbacks="myCallbacks"></v-tour>
    </div>
</div>
</template>

<script>
import PageItems from './partials/PageItems'
import PageNavigator from './partials/PageNavigator'
import CompanyTable from './partials/CompanyTable'
import CustomerForm from './partials/CustomerForm'
import makesAjaxRequests from '@/mixins/makesAjaxRequests'
import OldLink from '@/components/OldLink'
import qs from 'qs'

export default {
  name: 'FileDetails',

  mixins: [makesAjaxRequests],

  components: {
    CustomerForm,
    CompanyTable,
    PageItems,
    PageNavigator,
    OldLink,
  },

  props: {
    id: {
      type: [Number, String],
      required: true
    }
  },

  data: function () {
    return {
      ready: false,
      filterOptions: {
        status: [
          { value: 1, text: 'Pending' },
          { value: 2, text: 'Staged' },
          { value: 3, text: 'Settled' },
          { value: 4, text: 'Forwarded' }
        ],
        source: [
          { value: null, text: 'All Sources' },
          { value: 1, text: 'Downloaded' },
          { value: 2, text: 'Uploaded' },
          { value: 3, text: 'Generated' },
          { value: 4, text: 'Manual' },
          { value: 5, text: 'Forwarded' }
        ],
        company: []
      },
      filter: {
        status: 1,
        company: null,
        source: null
      },
      sort: {
        sort: 'company',
        reverse: 0
      },
      file: null,
      stats: {},
      companies: [],
      products: [],
      details: [],
      pagination: {
        per_page: 15
      },
      bulkAction: false,
      myCallbacks: {
        onPreviousStep: this.tourTabNavigatePrevious,
        onNextStep: this.tourTabNavigateNext
      },
      steps: [
        {
          target: '#pending',
          content: 'This tab will hold items that are being reconciled.<br>' +
            'You will be able to modify the information.<br>',
          params: {
            placement: 'top'
          }
        },
        {
          target: '#sourceFilter',
          content: 'Commissions in the table can be filtered by sources with this dropdown.',
          params: {
            placement: 'top'
          }
        },
        {
          target: '#companyFilter',
          content: 'Commissions in the table can be filtered by company with this dropdown.',
          params: {
            placement: 'top'
          }
        },
        {
          target: '.tag-red',
          content: 'If items were created outside of the normal method (uploads, manual entry, forwarded, carrier download) ' +
            'then they will be marked with the appropriate tag to indicate such.',
          params: {
            placement: 'top'
          }
        },
        {
          target: '#addCommissionDetail',
          content: 'If you need to add a new line item then you can use this area to do so.<br>' +
            "Note: By entering a customer name, a list of the customer's policies will be displayed.<br>" +
            'Remember to press add on each new commission to officially add the new commissions.',
          params: {
            placement: 'right'
          }
        },
        {
          target: '.thead-dark',
          content: 'Each column that contains a directional arrow may be used to sort the table data.'
        },
        {
          target: '.thead-dark > tr > th:nth-child(9)',
          content: 'The amount that you are earning commission on.'
        },
        {
          target: '.thead-dark > tr > th:nth-child(10)',
          content: 'The amount of commission that you should be paid based on your ' +
            'system settings. (Commission percentage and earn type)'
        },
        {
          target: '.thead-dark > tr > th:nth-child(11)',
          content: 'If your carrier sends you a different amount than we calculated then you can use this ' +
            'field to make those adjustments.'
        },
        {
          target: '#saveBtn',
          content: "Be sure to save your adjustments once you've edited them.",
          params: {
            placement: 'top'
          }
        },
        {
          target: '.thead-dark > tr > th:nth-child(12)',
          content: 'This shows the difference of the previous two columns.'
        },
        {
          target: '.thead-dark > tr > th.text-center > input',
          content: 'You can use the checkboxes on the left ' +
            'to select them so they can be processed further.',
          params: {
            placement: 'right'
          }
        },
        {
          target: '#stageBtn',
          content: 'This will send the selected items to staging so that they can be processed further.<br>' +
            'Note: This step is reversible from the staged tab, so if you stage something and decide it was ' +
            'not ready then you can always un-stage it so it can be edited again.',
          params: {
            placement: 'right'
          }
        },
        {
          target: '#forwardBtn',
          content: 'If you earned a commission that your carrier did not pay you on then you can use the forward button ' +
            'to put that commission into a pool on unpaid commissions which you expect to receive payment on at a later date.',
          params: {
            placement: 'top'
          }
        },
        {
          target: '#staged',
          content: 'Staged commissions will appear on this tab until they are used to generate an employee statement.',
          params: {
            placement: 'top'
          }
        },
        {
          target: '#unstageBtn',
          content: 'You may select and un-stage line items if you need to edit them further before processing them.',
          params: {
            placement: 'bottom'
          }
        },
        {
          target: '#statementsBtn',
          content: 'This is just a shortcut which takes you to "Admin >> Commission Statements" so you can ' +
            'process your employee commissions.',
          params: {
            placement: 'bottom'
          }
        },
        {
          target: '#settled',
          content: 'Items in this tab have already been processed by commission statement.<br>' +
            'Note: Once you have items in either this "Settled" tab or the "Forwarded" tab you will no longer be able to delete this file.',
          params: {
            placement: 'top'
          }
        },
        {
          target: '#forwarded',
          content: 'Outstanding carrier commissions are located.',
          params: {
            placement: 'top'
          }
        }
      ]
    }
  },

  created: function () {
    this.load(1)
  },

  watch: {
    id () {
      this.load(1)
    },

    filter: {
      deep: true,
      handler () {
        this.load(1)
      }
    },

    sort: {
      deep: true,
      handler () {
        this.load(1)
      }
    },

    'pagination.per_page': {
      handler (newVal, oldVal) {
        console.info(newVal, oldVal)
        return oldVal && newVal !== oldVal && this.load()
      }
    },

    companies () {
      this.filterOptions.company = this.companies.reduce((options, c) => {
        return [...options, {
          value: c.id,
          text: c.name
        }]
      }, [{ value: null, text: 'All Companies' }])
    }
  },

  computed: {
    isArchived () {
      return this.file.status === 1
    },

    hasItems () {
      return this.details.length > 0
    },

    selected () {
      return this.details.filter(i => i.selected)
    },

    selectedIds () {
      return this.bulkAction ? ['*'] : this.selected.map(i => i.id)
    },

    dirty () {
      return this.details.filter(i => i.dirty)
    }
  },

  methods: {
    clearFilter () {
      this.filter = {
        status: 1,
        company: null,
        customer: null,
        product: null,
        source: null
      }
    },

    load (page = null) {
      this.loadFile().then(() => this.loadPage(page))
    },

    loadFile () {
      return this.ajaxCall(this.$http.get(`commission/file/${this.id}/view`).then(resp => {
        this.file = resp.data.file
        this.companies = resp.data.companies
        this.products = resp.data.products
        this.$emit('setLoadingBar', 80)
      }).catch(err => {
        if (err.response.status === 404) {
          this.$router.push({ name: 'commissions.reconcile.main' })
        }

        if (err.response.status === 500) {
          this.error = err.response.data.message
        }

        return err
      }))
    },

    loadPage (page = null) {
      if (this.$route.query.status === 'selected') {
        this.filter.status = 3
      }

      var query = qs.stringify({
        ...this.sort,
        page: page || this.pagination.current_page,
        per_page: this.pagination.per_page
      })

      return this.ajaxCall(this.$http.post(`commission/file/${this.id}/details/list?${query}`, this.filter)
        .then(resp => {
          this.pagination = resp.data.pagination
          this.stats = resp.data.stats
          this.$emit('setLoadingBar', 100)
          let checkedIds = this.selectedIds
          let dirtyData = this.dirty
          this.details = resp.data.data.map(detail => {
            return {
              ...detail,
              selected: false,
              dirty: false,
              amount: detail.adjusted
            }
          })
          if (checkedIds) {
            let oldCheckedDetails = ((this.details).filter(function (detail) {
              return checkedIds.includes(detail.id)
            }))
            if (oldCheckedDetails) {
              oldCheckedDetails.map(detail => { detail.selected = true })
            }
          }

          dirtyData.forEach(dirtyDetail => {
            let detail = (this.details).find(i => i.id === dirtyDetail.id)
            if (detail) {
              detail.amount = dirtyDetail.amount
              detail.dirty = true
            }
          })
        }))
    },

    sortBy (field) {
      this.sort = {
        sort: field,
        reverse: this.sort.sort !== field || this.sort.reverse ? 0 : 1
      }
    },

    archive () {
      this.ajaxCall(this.$http.post(`commission/file/archive`, { ids: [this.id] }).then(resp => {
        this.load()
      }))
    },

    updateStatus (status) {
      this.updateDetails('update', this.selectedIds, { new_status: status })
    },

    deleteSelected () {
      this.updateDetails('delete', this.selectedIds)
    },

    updateDetails (method, details, options) {
      var data = {
        ...options,
        ...this.filter,
        details
      }

      return this.$http.post(`commission/file/${this.id}/details/${method}`, data).then(resp => {
        if (resp.data.affected_items >= this.pagination.total) {
          this.clearFilter()
        }

        this.loadPage()
      })
    },

    saveAdjustments () {
      var adjustments = this.dirty.map(i => {
        return { id: i.id, amount: i.amount }
      })

      if (adjustments.length === 0) {
        return
      }

      this.ajaxCall(this.updateDetails('adjust', adjustments).then(() => {
        adjustments.map(({ id, amount }) => {
          var detail = this.details.find(i => i.id === id)
          detail.adjusted = amount
          detail.dirty = false
        })
      }))
    },

    addNewDetail ({ detail, product, company, customer }) {
      if (!this.companies.find(c => c.id === company.id)) {
        this.companies.push(company)
      }

      if (!this.products.find(p => p.id === product.id)) {
        this.products.push(product)
      }

      this.details.push(detail)
    },

    checkUnsavedAdjustments () {
      var adjustments = this.dirty.map(i => {
        return { id: i.id, amount: i.amount }
      })

      if (adjustments.length !== 0) {
        if (confirm('You have unsaved adjusted amount. Do you wish to continue?')) {
          this.$router.push({
            name: 'commissions.reconcile.main',
            query: { status: 0 }
          })
        }
      } else {
        this.$router.push({
          name: 'commissions.reconcile.main',
          query: { status: 0 }
        })
      }
    },

    startHelpTour () {
      this.$tours['helpTour'].start()
    },

    tourTabNavigateNext (lastStep) {
      this.tourTabNavigate(lastStep + 1)
    },

    tourTabNavigatePrevious (lastStep) {
      this.tourTabNavigate(lastStep - 1)
    },

    tourTabNavigate (currentStep) {
      let pending = this.range(0, 13)
      let staged = this.range(14, 16)
      let settled = [17]
      let forwarded = [18]
      let tabSteps = []
      tabSteps[1] = pending
      tabSteps[2] = staged
      tabSteps[3] = settled
      tabSteps[4] = forwarded

      for (let key in tabSteps) {
        if ((tabSteps[key]).includes(currentStep)) {
          if (this.filter.status !== key) {
            this.$refs.tabsContainer.childNodes[key - 1].firstChild.click()
          }
          break
        }
      }
    },

    range (start, end) {
      var range = []
      for (;start <= end; start++) {
        range.push(start)
      }
      return range
    }
  }
}
</script>

<style lang="sass" scoped>
  .inactive
    background-color: #9aca63
    color: white

  .inactive:hover
    background-color: #4f7128

  .active
    background-color: #2777A3
    color: white

  .system-font
    font-family: Arial, Helvetica, sans-serif
    font-size: 11px

  .btn-tabs
    border-color: darkgray

  .btn
    -webkit-border-radius: 0
    -moz-border-radius: 0
    border-radius: 0

  #stageBtn, #saveBtn, #forwardBtn, #unstageBtn, #unforwardBtn, #deleteBtn, #resetBtn
    margin-right: 5px
    border-radius: 4px
    background-color: #2777A3
    color: white

  #statementsBtn
    margin-right: 5px
    border-radius: 4px

  #statementsLink
    color: white
    text-decoration: none

  .system-dropdown
    border-radius: 0
    margin-left: 7px

  .am-main-box-title
    padding: 10px 10px 0 10px
    float: left
    font-family: Arial, Helvetica, sans-serif
    font-size: 11px
    font-weight: bold

  #border-div
    margin: 3px -1px -10px -1px
    padding: 1px 1px 15px 1px

  #company-table
    margin-top: -8px

  #page-navigator
    margin-right: 10px

  .am-main-box
    height: 37px
    font-size: 11px
    font-weight: bold
    padding-right: 5px

  .bottom
    border-radius: 0 0 4px 4px
</style>
